import { ApiLayer } from '@/api/utils/api-layer';
import axios, { AxiosClient } from '@/api/utils/client/axios';
import { DateTimeZoneHelper } from '@/util/date-time-zone-helper';
import { trlMessage } from '@/services/i18n';

interface TimeZone {
  timezone: string;
}

interface TimeZoneUpdate {
  timezone: string;
}

interface TimeZoneItem {
  id: string;
}

interface TimeZoneItemFormat extends TimeZoneItem {
  order: number;
  title: string;
  offsetFormatted: string;
}

declare global {
  interface Window {
    Timezones: TimeZoneItem[];
  }
}

class TimeZoneLayer extends ApiLayer<AxiosClient> {
  /**
   * Получение часового пояса организации
   */
  getOrganizationTimeZone() {
    return this.methods.get<TimeZone>('/settings/timezone');
  }

  /**
   * Изменение часового пояса организации
   * @param payload
   */
  setOrganizationTimeZone(payload: TimeZoneUpdate) {
    return this.methods.post<TimeZone>('/settings/timezone', payload);
  }

  /**
   * Получение и форматирование списка часовых поясов
   */
  getTimezoneList() {
    return Promise.resolve(window.Timezones).then((list) => {
      return list
        .map<TimeZoneItemFormat>((item) => {
          const offsetFormatted = `GMT${DateTimeZoneHelper.getFormattedOffset(item.id)}`;
          return {
            ...item,
            order: DateTimeZoneHelper.getOffset(item.id),
            // eslint-disable-next-line no-restricted-syntax
            title: `${offsetFormatted} ${trlMessage(item.id)}`,
            offsetFormatted
          };
        })
        .sort((a, b) => a.order - b.order);
    });
  }
}
// TODO: переделать на именованный экспорт, в соответствии с README
export default new TimeZoneLayer(axios);
